export class QingAppRelationInfo{
    public userName =''
    public companyId =''
}